import axios from './axios'

export default {
  listStores() {
    return axios.get('/shopify/app/stores')
  },
  deleteStore(shop) {
    return axios.delete('/shopify/app/stores', {
      params: { shop }
    })
  },
  validateStore(shop, widgetType = 'feedback') {
    return axios.get('/shopify/app/stores/validate', {
      params: { shop, widget_type: widgetType }
    })
  },
  getStorefrontConfig(shop, widgetType = 'feedback') {
    return axios.get('/shopify/app/storefront-config', {
      params: { shop, widget_type: widgetType }
    })
  },
  saveStorefrontConfig(data) {
    return axios.post('/shopify/app/storefront-config', data)
  },
  getWidgetConfig(shop, widgetType = 'feedback') {
    return axios.get('/shopify/storefront/widget-config', {
      params: { shop, widget_type: widgetType }
    })
  }
}
